// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/* Container */

.theia-notifications-overlay {
  height: 0px;
}

.theia-notifications-container {
  position: absolute;
  bottom: 36px;
  right: 16px;
  width: 500px;
  user-select: none;
  z-index: 1111;
}
.theia-notifications-container.closed {
  display: none;
}
.theia-notifications-container > * {
  position: relative;
}

/* Toasts */

.theia-notifications-container.theia-notification-toasts .theia-notification-list-item-container {
  border-radius: 4px;
  margin-top: 6px;
}

.theia-notifications-container.theia-notification-toasts .theia-notification-list-item {
  box-shadow: 0px 0px 4px 0px var(--theia-widget-shadow);
  border: 1px solid var(--theia-notificationToast-border);
  border-radius: 4px;
}

/* Center */

.theia-notifications-container.theia-notification-center {
  background-color: var(--theia-notifications-background);
  border: 1px solid var(--theia-notificationCenter-border);
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 6px 0px var(--theia-widget-shadow);
}

/* Center > Header */

.theia-notification-center-header {
  color: var(--theia-notificationCenterHeader-foreground);
  background-color: var(--theia-notificationCenterHeader-background);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  min-height: 30px;
  align-items: center;
}

.theia-notification-center-header-title {
  font-size: calc(var(--theia-ui-font-size1) / 1.1);
  font-family: var(--theia-ui-font-family);
  margin: 8px;
  flex-grow: 2;
}

.theia-notification-center-header-actions {
  margin: 8px;
}

/* List */

.theia-notification-list-scroll-container {
  max-height: 300px;
  overflow: auto;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.theia-notification-list {
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
}

/* List > Item */

.theia-notification-list-item {
  background-color: var(--theia-notifications-background);
  width: 100%;
  cursor: pointer;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.theia-notification-list-item:focus {
  border-color: var(--theia-focusBorder);
}

.theia-notification-center .theia-notification-list-item:not(:last-child) {
  border-top: 1px var(--theia-notifications-border) solid;
}

.theia-notification-list-item-content {
  margin: 6px;
  flex-grow: 3;
}
.theia-notification-list-item-content.collapsed
  .theia-notification-list-item-content-bottom {
  display: none;
}
.theia-notification-list-item-content.collapsed .theia-notification-message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-notification-list-item-content-main {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 5px 4px 7px 4px;
}

.theia-notification-message {
  font-size: var(--theia-ui-font-size1);
  font-family: var(--theia-ui-font-family);
  overflow-wrap: break-word;
  box-sizing: border-box;
  flex-basis: 0%;
  flex-grow: 1;
  flex-shrink: 1;
  display: block;
  overflow: hidden;
  user-select: text;
  margin-top: 3px;
}

.theia-notification-message a {
  border: none;
  color: var(--theia-notificationLink-foreground);
  outline: 0;
  text-decoration: none;
}
.theia-notification-message a:focus {
  outline-color: var(--theia-focusBorder);
}

.theia-notification-icon {
  margin-top: 1px;
}

.theia-notification-icon:before {
  font-size: 18px;
  padding-right: 4px;
}

.theia-notification-icon.info:before {
  color: var(--theia-notificationsInfoIcon-foreground);
}

.theia-notification-icon.warning:before {
  color: var(--theia-notificationsWarningIcon-foreground);
}

.theia-notification-icon.error:before {
  color: var(--theia-notificationsErrorIcon-foreground);
}

.theia-notification-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 0px;
  padding: 0px;
}

.theia-notification-actions > li {
  display: inline-block;
  height: 16px;
  width: 16px;
  cursor: pointer;
  margin-left: 4px;
}

.theia-notification-actions > .expand {
  transform: rotate(180deg);
}

.theia-notification-list-item-content-bottom {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.theia-notification-source {
  font-size: var(--theia-ui-font-size0);
  font-family: var(--theia-ui-font-family);
  overflow-wrap: break-word;
  box-sizing: border-box;
  flex-grow: 1;
  padding: 4px;
  display: block;
  overflow: hidden;
}

.theia-notification-buttons {
  flex-grow: 2;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.theia-notification-buttons > button {
  margin: 4px;
  max-width: 160px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.theia-notification-item-progress {
  display: block;
}

.theia-notification-item-progressbar {
  height: 2px;
  background-color: var(--theia-progressBar-background);
  width: 66%;
}

.theia-notification-item-progressbar.indeterminate {
  /* \`progress-animation\` is defined in \`packages/core/src/browser/style/progress-bar.css\` */
  animation: progress-animation 1.3s 0s infinite
    cubic-bezier(0.645, 0.045, 0.355, 1);
}

/* Perfect scrollbar */

.theia-notification-list-scroll-container .ps__rail-y {
  width: var(--theia-scrollbar-rail-width);
}

.theia-notification-list-scroll-container .ps__rail-y:hover > .ps__thumb-y,
.theia-notification-list-scroll-container .ps__rail-y:focus > .ps__thumb-y,
.theia-notification-list-scroll-container
  .ps__rail-y.ps--clicking
  .ps__thumb-y {
  right: calc(
    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2
  );
  width: var(--theia-scrollbar-width);
}

.theia-notification-list-scroll-container .ps__rail-y > .ps__thumb-y {
  width: var(--theia-scrollbar-width);
  right: calc(
    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2
  );
  background: var(--theia-scrollbarSlider-background);
  border-radius: 0px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/messages/src/browser/style/notifications.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF,cAAc;;AAEd;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,uDAAuD;EACvD,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA,oBAAoB;;AAEpB;EACE,uDAAuD;EACvD,kEAAkE;EAClE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;EACxC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,SAAS;;AAET;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,gBAAgB;;AAEhB;EACE,uDAAuD;EACvD,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,UAAU;AACZ;;AAEA;EACE,0FAA0F;EAC1F;wCACsC;AACxC;;AAEA,sBAAsB;;AAEtB;EACE,wCAAwC;AAC1C;;AAEA;;;;;EAKE;;GAEC;EACD,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC;;GAEC;EACD,mDAAmD;EACnD,kBAAkB;AACpB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/* Container */\n\n.theia-notifications-overlay {\n  height: 0px;\n}\n\n.theia-notifications-container {\n  position: absolute;\n  bottom: 36px;\n  right: 16px;\n  width: 500px;\n  user-select: none;\n  z-index: 1111;\n}\n.theia-notifications-container.closed {\n  display: none;\n}\n.theia-notifications-container > * {\n  position: relative;\n}\n\n/* Toasts */\n\n.theia-notifications-container.theia-notification-toasts .theia-notification-list-item-container {\n  border-radius: 4px;\n  margin-top: 6px;\n}\n\n.theia-notifications-container.theia-notification-toasts .theia-notification-list-item {\n  box-shadow: 0px 0px 4px 0px var(--theia-widget-shadow);\n  border: 1px solid var(--theia-notificationToast-border);\n  border-radius: 4px;\n}\n\n/* Center */\n\n.theia-notifications-container.theia-notification-center {\n  background-color: var(--theia-notifications-background);\n  border: 1px solid var(--theia-notificationCenter-border);\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0px 0px 6px 0px var(--theia-widget-shadow);\n}\n\n/* Center > Header */\n\n.theia-notification-center-header {\n  color: var(--theia-notificationCenterHeader-foreground);\n  background-color: var(--theia-notificationCenterHeader-background);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  min-height: 30px;\n  align-items: center;\n}\n\n.theia-notification-center-header-title {\n  font-size: calc(var(--theia-ui-font-size1) / 1.1);\n  font-family: var(--theia-ui-font-family);\n  margin: 8px;\n  flex-grow: 2;\n}\n\n.theia-notification-center-header-actions {\n  margin: 8px;\n}\n\n/* List */\n\n.theia-notification-list-scroll-container {\n  max-height: 300px;\n  overflow: auto;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.theia-notification-list {\n  display: flex;\n  flex-direction: column-reverse;\n  flex-wrap: nowrap;\n}\n\n/* List > Item */\n\n.theia-notification-list-item {\n  background-color: var(--theia-notifications-background);\n  width: 100%;\n  cursor: pointer;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n}\n\n.theia-notification-list-item:focus {\n  border-color: var(--theia-focusBorder);\n}\n\n.theia-notification-center .theia-notification-list-item:not(:last-child) {\n  border-top: 1px var(--theia-notifications-border) solid;\n}\n\n.theia-notification-list-item-content {\n  margin: 6px;\n  flex-grow: 3;\n}\n.theia-notification-list-item-content.collapsed\n  .theia-notification-list-item-content-bottom {\n  display: none;\n}\n.theia-notification-list-item-content.collapsed .theia-notification-message {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-notification-list-item-content-main {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  padding: 5px 4px 7px 4px;\n}\n\n.theia-notification-message {\n  font-size: var(--theia-ui-font-size1);\n  font-family: var(--theia-ui-font-family);\n  overflow-wrap: break-word;\n  box-sizing: border-box;\n  flex-basis: 0%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  display: block;\n  overflow: hidden;\n  user-select: text;\n  margin-top: 3px;\n}\n\n.theia-notification-message a {\n  border: none;\n  color: var(--theia-notificationLink-foreground);\n  outline: 0;\n  text-decoration: none;\n}\n.theia-notification-message a:focus {\n  outline-color: var(--theia-focusBorder);\n}\n\n.theia-notification-icon {\n  margin-top: 1px;\n}\n\n.theia-notification-icon:before {\n  font-size: 18px;\n  padding-right: 4px;\n}\n\n.theia-notification-icon.info:before {\n  color: var(--theia-notificationsInfoIcon-foreground);\n}\n\n.theia-notification-icon.warning:before {\n  color: var(--theia-notificationsWarningIcon-foreground);\n}\n\n.theia-notification-icon.error:before {\n  color: var(--theia-notificationsErrorIcon-foreground);\n}\n\n.theia-notification-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  margin: 0px;\n  padding: 0px;\n}\n\n.theia-notification-actions > li {\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n  cursor: pointer;\n  margin-left: 4px;\n}\n\n.theia-notification-actions > .expand {\n  transform: rotate(180deg);\n}\n\n.theia-notification-list-item-content-bottom {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.theia-notification-source {\n  font-size: var(--theia-ui-font-size0);\n  font-family: var(--theia-ui-font-family);\n  overflow-wrap: break-word;\n  box-sizing: border-box;\n  flex-grow: 1;\n  padding: 4px;\n  display: block;\n  overflow: hidden;\n}\n\n.theia-notification-buttons {\n  flex-grow: 2;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.theia-notification-buttons > button {\n  margin: 4px;\n  max-width: 160px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.theia-notification-item-progress {\n  display: block;\n}\n\n.theia-notification-item-progressbar {\n  height: 2px;\n  background-color: var(--theia-progressBar-background);\n  width: 66%;\n}\n\n.theia-notification-item-progressbar.indeterminate {\n  /* `progress-animation` is defined in `packages/core/src/browser/style/progress-bar.css` */\n  animation: progress-animation 1.3s 0s infinite\n    cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n/* Perfect scrollbar */\n\n.theia-notification-list-scroll-container .ps__rail-y {\n  width: var(--theia-scrollbar-rail-width);\n}\n\n.theia-notification-list-scroll-container .ps__rail-y:hover > .ps__thumb-y,\n.theia-notification-list-scroll-container .ps__rail-y:focus > .ps__thumb-y,\n.theia-notification-list-scroll-container\n  .ps__rail-y.ps--clicking\n  .ps__thumb-y {\n  right: calc(\n    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2\n  );\n  width: var(--theia-scrollbar-width);\n}\n\n.theia-notification-list-scroll-container .ps__rail-y > .ps__thumb-y {\n  width: var(--theia-scrollbar-width);\n  right: calc(\n    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2\n  );\n  background: var(--theia-scrollbarSlider-background);\n  border-radius: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
